import Navbar from "./components/Navbar";
import { Route, Routes, Navigate } from "react-router-dom";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import SuccessStoriesPage from "./pages/SuccessStoriesPage";
import CarrersPage from "./pages/CareersPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PeoplePage from "./pages/PeoplePage";
import WhoWeArePage from "./pages/WhoWeArePage";
import SchedulePage from "./pages/ScheduleCallPage";

const App: React.FC = () => {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/success-stories" element={<SuccessStoriesPage />} />
        <Route path="/careers" element={<CarrersPage />} />
        <Route path="/people" element={<PeoplePage />} />
        <Route path="/who-we-are" element={<WhoWeArePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
    </>
  );
};
export default App;
